<template>
    <generic-page>
        <div>
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else>
                <b-list-group flush>
                    <b-list-group-item
                        action
                        :key="creatorVideo.id"
                        v-for="{ creatorVideo } in creatorVideos"
                        @click="
                            $router.push({
                                name: 'videoView',
                                params: {
                                    id: creatorVideo.id,
                                },
                            })
                        "
                    >
                        <video-avatar :creatorVideo="creatorVideo" />
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<script>
import { mapState } from "vuex";

import GenericPagination from "@/components/utility/GenericPagination";
import VideoAvatar from "@/components/video/VideoAvatar";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            creatorVideos: null,
            loading: false,
        };
    },
    created() {
        this.refresh();
    },
    computed: {
        ...mapState("profile", ["profile"]),
    },
    methods: {
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post("/video/index", {
                    page: this.page,
                    view: "user",
                    userId: this.profile.id,
                })
                .then((response) => {
                    this.creatorVideos = response?.data?.creatorVideos;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        GenericPagination,
        VideoAvatar,
    },
};
</script>